import React from "react";
import { VENUES } from "../mock";

const Venues = () => {
  // duplicate the list for seamless marquee
  const marqueeList = [...VENUES, ...VENUES, ...VENUES];

  return (
    <section id="venues" className="py-24 md:py-32 bg-[#f5efe6] overflow-hidden">
      {/* Marquee strip */}
      <div className="relative overflow-hidden mb-20">
        <div className="vv-marquee-track">
          {marqueeList.map((v, i) => (
            <span key={i} className="venue-chip">
              {v.name}<span className="dot" />
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16 reveal">
          <p className="kicker mb-5">Essex Wedding Venues</p>
          <h2 className="font-display display-tight text-5xl md:text-6xl text-[#1f1d1a]">
            We know Essex venues <span className="italic font-light">inside out</span>
          </h2>
          <div className="section-rule mt-8" />
          <p className="mt-6 text-[#3a342c]/80 font-light text-[1rem] leading-relaxed">
            We've photographed and filmed at all of these venues (and loads more). We know every angle, every lighting sweet spot, and every hidden corner.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {VENUES.map((v, i) => (
            <div key={i} className="reveal group cursor-pointer">
              <div className="relative overflow-hidden aspect-[4/5]">
                <img
                  src={v.img}
                  alt={v.name}
                  className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-110"
                  onError={(e) => { e.currentTarget.style.background = "#3a342c"; }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1f1d1a]/85 via-[#1f1d1a]/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-display text-2xl text-[#f5efe6] display-tight">{v.name}</h3>
                  <p className="text-[0.65rem] tracking-[0.3em] uppercase text-[#c9a87c] mt-1">View photos &amp; films</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Venues;
